<template>
    <div>
        <template v-for="(n, i) in lignesCount">
            <b-row :key="'row_' + i" class="mb-2">
                <b-col cols="7">
                    <b-form-select
                            :key="'select_' + i"
                            v-model="infosLignes[i].ligneId"
                            required
                            @change="emit">
                        <b-form-select-option v-for="(ligne,index) in lignes" :key="index"
                                              :value="ligne.value.id"
                                              :disabled="isDisabled(ligne.value.id)">
                            {{ligne.text}}
                        </b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col cols="3">
                    <b-form-input
                            v-if="lignesCount > 1"
                            v-model="infosLignes[i].ponderation"
                            type="number"
                            step="any"
                            min="0"
                            max="100"
                            :trim="true"
                            @input="emit"
                            placeholder="Pondération"
                            required>
                    </b-form-input>
                </b-col>
                <b-col cols="1" v-if="n === lignesCount && infosLignes[i] != null">
                    <Icon icon="plus" size="2x" :key="'add_' + i" @click="addSelect"
                          class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
                <b-col cols="1" v-if="lignesCount === n && n > 1">
                    <Icon icon="minus" size="2x" :key="'remove_' + i"
                          @click="removeSelect(i)" class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
            </b-row>
        </template>
    </div>

</template>

<script>


  import LigneStore from "../../stores/LigneStore";
  import MarcheLigneInfosDto from "../../dtos/MarcheLigneInfosDto";

  export default {
    name: "LigneMarche",
    props: ['value', 'marcheId'],
    data() {
      return {
        lignesCount: 1,
        infosLignes: [new MarcheLigneInfosDto(this.marcheId)],
        lignes: [],
      }
    },
    watch: {
      value: function (vals) {
        this.initLignes(vals);
      }
    },
    mounted() {
      LigneStore.getAll().then(
          response => this.lignes = response.map(value => {
            return {text: value.libelleLong, value: value};
          })
      );
      this.initLignes(this.value);
    },
    methods: {
      initLignes(vals) {
        if (vals && vals.length > 0) {
          this.infosLignes = vals;
          this.lignesCount = vals.length;
        } else {
          const defaultLigne = new MarcheLigneInfosDto(this.marcheId);
          defaultLigne.ponderation = 100;
          this.infosLignes = [defaultLigne];
          this.lignesCount = 1;
        }
      },
      emit() {
        this.$emit('input', this.infosLignes);
      },
      addSelect() {
        this.infosLignes.push(new MarcheLigneInfosDto(this.marcheId));
        this.lignesCount++;
      },
      removeSelect(index) {
        this.lignesCount--;
        this.infosLignes.splice(index, 1);
        if (this.lignesCount === 1) {
          this.infosLignes[0].ponderation = 100;
        }
        this.emit();
      },
      isDisabled(ligneId) {
        return this.infosLignes.findIndex(infoLigne => infoLigne.ligneId === ligneId) !== -1;
      }
    }
  };
</script>
